import styled from 'styled-components';
import { Card, Col } from 'antd';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const GradientHeader = styled.div`
  padding: 32px 24px;
  border-radius: 12px;
  background: linear-gradient(90deg, #1d262c 0%, #2c3a43 100%);
`;

export const SummaryCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  .ant-statistic-title {
    font-weight: 600;
  }
`;

export const SummaryCol = styled(Col)`
  min-width: 200px;
`;

export const Section = styled.div`
  padding: 24px 0px;
`;
